export const SET_QUICKSEARCH_COUNTRY = 'SET_QUICKSEARCH_COUNTRY';
export const SET_QUICKSEARCH_DEPARTURE_DATE = 'SET_QUICKSEARCH_DEPARTURE_DATE';
